<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-10 offset-lg-1 mt-4">
                    <div class="intro col-12">
                        <h2 class="mb-2">Mijn adviseur</h2>
                        <slot name="introductionText"></slot>
                    </div>
                    <div v-if="profile != {}" class="col-12">
                        <h3>Gegevens adviseur:</h3>
                        <div
                            v-for="(item, index) in profile"
                            :key="index"
                            class="container border-bottom-2 pb-2 mb-2 pl-0 ml-0"
                        >
                            <dl class="row">
                                <dt class="col-sm-3 pb-0">Naam:</dt>
                                <dd class="col-sm-9 text-left pb-0">
                                    {{ item.Name }}
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-3 pb-0">
                                    Telefoon:
                                </dt>
                                <dd class="col-sm-9 text-left pb-0">
                                    {{ item.CEGphone }}
                                </dd>
                            </dl>
                            <dl class="row">
                                <dt class="col-sm-3 pb-0">
                                    E-mailadres:
                                </dt>
                                <dd class="col-sm-9 text-left pb-0">
                                    {{ item.Email }}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        user: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            profile: []
        };
    },
    created() {
        this.profile = JSON.parse(this.user);
    }
};
</script>
